<template>
  <div id="crew-labor-template" class="h-full">
    <div class="flex justify-between items-center" style="padding-top: 2px;">
      <div class="flex items-center pl-2">
        <div class="aisea-text-18-600-dark-gray">労務基本情報</div>
        <v-select
          placeholder="-"
          :disabled="isEmptyTemplates"
          v-model="selectedTemplate"
          class="w-64 ml-4"
          name="templates"
          label="label"
          :options="templates"
          :clearable="false"
          @input="inputTemplate()"
        />
      </div>

      <div class="flex items-center">
        <vx-tooltip text="編集" position="bottom">
          <feather-icon
            v-if="!isEmptyTemplates"
            icon="Edit2Icon"
            svg-classes="h-4 w-4 m-4"
            :class="disabledButton ? 'disabled-icon' : 'crew-list-hover-icon'"
            @click.stop="showCrewSidebarForEdit()"
          />
        </vx-tooltip>
        <vx-tooltip text="削除" position="bottom">
          <feather-icon
            v-if="!isEmptyTemplates"
            icon="TrashIcon"
            svg-classes="h-4 w-4 m-4"
            :class="disabledButton ? 'disabled-icon' : 'crew-list-hover-icon'"
            @click.stop="confirmDelete()"
          />
        </vx-tooltip>
        <vs-button
          class="ml-4"
          type="border"
          icon="add"
          style="margin: 0 0.6rem; height: 2.7rem;"
          :color="AISEA_COLOR.BLUE"
          @click="showCrewSidebarForCreate"
        >
          <span class="aisea-text-14-400-blue">新規登録</span>
        </vs-button>
      </div>
    </div>
    <vs-divider style="margin-top: 8px;" />
    <div
      v-if="isEmptyTemplates"
      class="h-full flex items-center justify-center"
    >
      <div>
        <p class="py-2 text-center">表示する労務基本情報がありません。</p>
        <vs-button
          class="w-full"
          type="border"
          icon-pack="feather"
          icon="icon-plus"
          :color="AISEA_COLOR.BLUE"
          @click="showCrewSidebarForCreate"
        >
          新規登録
        </vs-button>
      </div>
    </div>
    <div v-else-if="selectedTemplate" class="scroll-area">
      <div class="m-6 text-sm">
        <vs-row>
          <vs-col vs-w="3" class="pr-4 aisea-text-14-400-black"
            >テンプレート</vs-col
          >
          <vs-col vs-w="9" class="aisea-text-16-400-black">
            {{ templateLabel }}
          </vs-col>
        </vs-row>
        <vs-divider />
        <vs-row>
          <vs-col vs-w="3" class="pr-4 aisea-text-14-400-black"
            >労働管理責任者</vs-col
          >
          <vs-col vs-w="9" class="aisea-text-16-400-black">
            {{ laborMgmtRep }}
          </vs-col>
        </vs-row>
        <vs-divider />
        <vs-row>
          <vs-col vs-w="3" class="pr-4 aisea-text-14-400-black"
            >基準労働期間</vs-col
          >
          <vs-col vs-w="9" class="aisea-text-16-400-black">
            {{ workPeriodMonth }}
          </vs-col>
        </vs-row>
        <vs-divider />
        <vs-row>
          <vs-col vs-w="3" class="pr-4 aisea-text-14-400-black"
            >基準労働期間起算日及び末日</vs-col
          >
          <vs-col vs-w="9" class="aisea-text-16-400-black">
            {{ workPeriodRange }}
          </vs-col>
        </vs-row>
        <vs-divider />
        <vs-row>
          <vs-col vs-w="3" class="pr-4 aisea-text-14-400-black"
            >時間外労使協定の有無</vs-col
          >
          <vs-col vs-w="9" class="aisea-text-16-400-black">
            {{ overtimeLaborAgrmt }}
          </vs-col>
        </vs-row>
        <vs-divider />
        <vs-row>
          <vs-col vs-w="3" class="pr-4 aisea-text-14-400-black"
            >補償休日労働協定の有無</vs-col
          >
          <vs-col vs-w="9" class="aisea-text-16-400-black">
            {{ compensatoryTimeOffLaborAgrmt }}
          </vs-col>
        </vs-row>
        <vs-divider />
        <vs-row>
          <vs-col vs-w="3" class="pr-4 aisea-text-14-400-black"
            >休息時間分割回数協定の有無</vs-col
          >
          <vs-col vs-w="9" class="aisea-text-16-400-black">
            {{ breakLaborAgrmt }}
          </vs-col>
        </vs-row>
        <vs-divider />
        <vs-row>
          <vs-col vs-w="3" class="pr-4 aisea-text-14-400-black"
            >休日日数の定めの有無</vs-col
          >
          <vs-col vs-w="9" class="aisea-text-16-400-black">
            {{ mandatoryDayOff }}
          </vs-col>
        </vs-row>
        <vs-divider />
        <vs-row>
          <vs-col vs-w="3" class="pr-4 aisea-text-14-400-black"
            >休日日数を定めている場合の日数</vs-col
          >
          <vs-col vs-w="9" class="aisea-text-16-400-black">
            {{ numOfMandatoryDayOff }}
          </vs-col>
        </vs-row>
        <vs-divider />
        <vs-row>
          <vs-col vs-w="3" class="pr-4 aisea-text-14-400-black"
            >有給休暇の必要日数</vs-col
          >
          <vs-col vs-w="9" class="aisea-text-16-400-black">
            {{ numOfMandatoryPaidTimeOff }}
          </vs-col>
        </vs-row>
        <vs-divider />
        <vs-row>
          <vs-col vs-w="3" class="pr-4 aisea-text-14-400-black"
            >法第72条特例への該当有無</vs-col
          >
          <vs-col vs-w="9" class="aisea-text-16-400-black">
            {{ marinersLawArt72Applicable }}
          </vs-col>
        </vs-row>
        <vs-divider />
        <vs-row>
          <vs-col vs-w="3" class="pr-4 aisea-text-14-400-black"
            >一日当たりの労働時間上限</vs-col
          >
          <vs-col vs-w="9" class="aisea-text-16-400-black">
            {{ maxWorkHourPerDay }}
          </vs-col>
        </vs-row>
        <vs-divider />
        <vs-row>
          <vs-col vs-w="3" class="pr-4 aisea-text-14-400-black"
            >労務情報の基本テンプレート適用</vs-col
          >
          <vs-col vs-w="9" class="aisea-text-16-400-black">
            {{ isDefault }}
          </vs-col>
        </vs-row>
      </div>
    </div>
  </div>
</template>

<script>
import { ColorMixin } from "@/mixins";
import vSelect from "vue-select";
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState, mapMutations } = createNamespacedHelpers("crewLaborTemplate");

export default {
  mixins: [ColorMixin],
  props: {
    activeSidebarCrew: Boolean,
    activeTab: Number,
  },
  components: {
    vSelect,
  },
  data () {
    return {
      crewLaborTemplateParam: {},
      workPeriodFrom: null,
      workPeriodTo: null,

    }
  },
  computed: {
    ...mapState(["templates", "template"]),
    templateLabel () {
      if (!this.selectedTemplate) return "未設定"
      return this.selectedTemplate.label ? this.selectedTemplate.label : "未設定"
    },
    laborMgmtRep () {
      return this.selectedTemplate.labor_mgmt_rep ? this.selectedTemplate.labor_mgmt_rep : "-"
    },
    workPeriodMonth () {
      return this.selectedTemplate.work_period_month ? `${this.selectedTemplate.work_period_month}ヶ月` : "-"
    },
    workPeriodRange () {
      if (!this.workPeriodFrom || !this.workPeriodTo) return "-";
      return `${this.workPeriodFrom} 〜 ${this.workPeriodTo}`
    },
    overtimeLaborAgrmt () {
      return "overtime_labor_agrmt" in this.selectedTemplate ? this.boolToText(this.selectedTemplate.overtime_labor_agrmt) : "-"
    },
    compensatoryTimeOffLaborAgrmt () {
      return "compensatory_time_off_labor_agrmt" in this.selectedTemplate ? this.boolToText(this.selectedTemplate.compensatory_time_off_labor_agrmt) : "-"
    },
    breakLaborAgrmt () {
      return "break_labor_agrmt" in this.selectedTemplate ? this.boolToText(this.selectedTemplate.break_labor_agrmt) : "-"
    },
    mandatoryDayOff () {
      return "mandatory_day_off" in this.selectedTemplate ? this.boolToText(this.selectedTemplate.mandatory_day_off) : "-"
    },
    numOfMandatoryDayOff () {
      return this.selectedTemplate.num_of_mandatory_day_off ? `${this.selectedTemplate.num_of_mandatory_day_off}日` : "-"
    },
    numOfMandatoryPaidTimeOff () {
      return this.selectedTemplate.num_of_mandatory_paid_time_off ? `${this.selectedTemplate.num_of_mandatory_paid_time_off}日` : "-"
    },
    marinersLawArt72Applicable () {
      return "mariners_law_art_72_applicable" in this.selectedTemplate ? this.boolToText(this.selectedTemplate.mariners_law_art_72_applicable) : "-"
    },
    maxWorkHourPerDay () {
      if (!this.selectedTemplate.max_work_hour_per_day) return "-"
      return `${this.selectedTemplate.max_work_hour_per_day}時間`
    },
    isDefault () {
      if (!this.selectedTemplate) return "-"
      if (!("is_default" in this.selectedTemplate)) return "-"
      return this.selectedTemplate.is_default ? "はい" : "いいえ"
    },

    selectedTemplate: {
      get () { return this.template },
      set (val) { this.SET_TEMPLATE(val) },
    },

    disabledButton () {
      return this.isEmptyTemplates || Object.keys(this.selectedTemplate).length === 0;
    },
    isEmptyTemplates () {
      return this.templates.length === 0;
    },
    sidebarStatus: {
      get () { return this.activeSidebarCrew; },
      set (val) { this.$emit('update:activeSidebarCrew', val) }
    },
    defaultTemplate () {
      if (!this.templates) return undefined;
      return this.templates.find(t => t.is_default);
    },
    latestTemplate () {
      if (!this.templates) return undefined;
      return this.templates.at(-1);
    },
  },
  methods: {
    ...mapMutations(["SET_TEMPLATE"]),
    ...mapActions(["fetchTemplateList", "deleteTemplate", "fetchTemplate"]),
    inputTemplate () {
      this.fetchTemplate(this.selectedTemplate.id)
    },
    showCrewSidebarForEdit () {
      this.crewLaborTemplateParam = { id: this.selectedTemplate.id };
      this.$emit('setDialogTitle', '労務基本情報編集');
      this.sidebarStatus = true;
    },
    showCrewSidebarForCreate () {
      this.crewLaborTemplateParam = { id: null };
      this.$emit('setDialogTitle', '労務基本情報登録');
      this.sidebarStatus = true;
    },
    confirmDelete () {
      // const name = data ? data.name : this.dispUsers.find(x => x.user_id === this.hoveredIdByRow).name;
      const name = this.selectedTemplate.label;
      this.$vs.dialog({
        type: "confirm",
        color: this.AISEA_COLOR.BLUE,
        title: `削除確認`,
        text: `${name}を削除しますか？
削除されたテンプレートデータは復元されません。${name}を適用した船員の労務情報は変更されません。`,
        acceptText: "削除",
        cancelText: "キャンセル",
        accept: this.onDelete
      });
    },
    async onDelete () {
      await this.deleteTemplate(this.selectedTemplate.id)
      this.$vs.notify({
        title: `労務基本情報`,
        text: `${this.selectedTemplate.label}を削除しました`,
        color: "success",
        iconPack: "feather",
        icon: "icon-check"
      });
      await this.fetchTemplateList();
      this.initSelectedTemplate();
    },
    boolToText (bool) {
      return bool ? "有" : "無"
    },
    initSelectedTemplate () {
      const toBeselectedTemplate = (!this.isEmptyTemplates)
        ? this.defaultTemplate || this.latestTemplate
        : {};
      this.selectedTemplate = toBeselectedTemplate;
    },
  },
  watch: {
    activeSidebarCrew (val) {
      if (!val) {
        document.getElementById("crew-labor-template").click();
      }
    },
    selectedTemplate (val) {
      const numToDateFormat = (num => `0${num}`.slice(-2));
      this.workPeriodFrom = `${numToDateFormat(val.work_period_from_month)}/${numToDateFormat(val.work_period_from_day)}`;
      this.workPeriodTo = `${numToDateFormat(val.work_period_to_month)}/${numToDateFormat(val.work_period_to_day)}`;
    },
  },
  async created () {
    await this.fetchTemplateList();
    this.initSelectedTemplate();
  },
  mounted () {

  },
}
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

#crew-labor-template {
  .scroll-area {
    overflow-y: auto;
    height: calc(100% - 60px);
  }

  .crew-list-hover-icon {
    border-radius: 4px;
    color: $aisea-gray;
    &:hover {
      background-color: $aisea-light-gray;
    }
  }

  .disabled-icon {
    border-radius: 4px;
    color: $aisea-mouse-gray;
  }

  .v-select {
    font-family: $aisea-font-family;
    font-size: 16px;
    font-weight: 400;

    input {
      height: 2rem;
    }
  }
}
</style>
  